var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0873 15.0001C18.8993 11.6072 18.5485 6.60339 15.2905 3.63616C12.0325 0.668926 7.01774 0.785973 3.90173 3.90198C0.785729 7.01798 0.668682 12.0327 3.63591 15.2907C6.60315 18.5487 11.607 18.8996 14.9998 16.0876L21.1949 22.2826L22.2598 21.2176L16.0873 15.0001ZM9.74986 16.5001C6.02194 16.5001 2.99986 13.478 2.99986 9.7501C2.99986 6.02218 6.02194 3.0001 9.74986 3.0001C13.4778 3.0001 16.4999 6.02218 16.4999 9.7501C16.4999 13.478 13.4778 16.5001 9.74986 16.5001Z",
    fill: "#F8FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchbox);
export default __webpack_public_path__ + "static/media/searchbox.b3e1bec872040a92b84d63e5ea0084d8.svg";
export { ForwardRef as ReactComponent };